import { render } from "./EditSubStamp.vue?vue&type=template&id=272dc9a6&scoped=true"
import script from "./EditSubStamp.vue?vue&type=script&lang=js"
export * from "./EditSubStamp.vue?vue&type=script&lang=js"

import "./EditSubStamp.vue?vue&type=style&index=0&id=272dc9a6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272dc9a6"]])

export default __exports__